import Controller from '../abstracts/Controller';
import 'scss-templates/t-listing.scss';

export default class ListingController extends Controller {
  static get COMPONENTS() {
    return [
      'FiltersComponent',
      'ShortcutComponent',
      'ListingHeadComponent',
      'CategoryFilterComponent',
      'SearchComponent',
      'PaginationComponent',
      'ActiveFiltersComponent',
      'CarouselComponent',
      'RecommendationEngineComponent',
      'ListingEditorialComponent',
      'WishlistComponent',
      'VisualMerchandisingComponent',
      'HistoryManagerComponent',
      'SaleRangeComponent',
      'SalesScrollbarComponent',
      'SeoTextComponent',
      'SizeGuideComponent'
    ];
  }
}
